module.exports = __webpack_public_path__ + "files/7916c600f786327637e82910dd7f1077.png";